module.exports = __webpack_public_path__ + "static/media/cart.9dec99fe.9dec99fe.png";